import { createReducer } from "@reduxjs/toolkit";



export const userReducer = createReducer({},{
    loginRequest:(state)=>{
        state.loading = true;
    },
    loginSuccess:(state,action)=>{
        state.loading = false;
        state.isAuth = true;
        state.user = action.payload.user;
        state.message = action.payload.message;
    },
    loginFail:(state,action)=>{
        state.loading = false;
        state.isAuth = true;
        state.error = action.payload;
    },

    loadUserRequest:(state)=>{
        state.loading = true;
    },
    loadUserSuccess:(state,action)=>{
        state.loading = false;
        state.isAuth = true;
        state.user = action.payload;
        // state.message = action.payload.message;
    },
    loadUserFail:(state,action)=>{
        state.loading = false;
        state.isAuth = true;
        state.error = action.payload;
    },

    logoutRequest:(state)=>{
        state.loading = true;
    },
    logoutSuccess:(state,action)=>{
        state.loading = false;
        state.isAuth = false;
        state.user = null;
        state.message = action.payload;
    },
    logoutFail:(state,action)=>{
        state.loading = false;
        state.isAuth = true;
        state.error = action.payload;
    },

    registerRequest:(state)=>{
        state.loading = true;
    },
    registerSuccess:(state,action)=>{
        state.loading = false;
        state.isAuth = true;
        state.user = action.payload.user;
        state.message = action.payload.message;
    },
    registerFail:(state,action)=>{
        state.loading = false;
        state.isAuth = true;
        state.error = action.payload;
    },

    removeFromPlaylistRequest:(state)=>{
        state.loading = true;
    },
    removeFromPlaylistSuccess:(state,action)=>{
        state.loading = false;
        state.message = action.payload;
    },
    removeFromPlaylistFail:(state,action)=>{
        state.loading = false;
        state.error = action.payload;
    },

    clearError:(state)=>{
        state.error=null
    },
    clearMessage:(state)=>{
        state.message=null;
    },
})